import React from "react";
import { createRoot } from "react-dom/client";
import { SiteConfigurator } from "../app/site-configurator";
import "../app/globals.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SiteConfigurator />
  </React.StrictMode>,
);
